import React, { ReactNode } from 'react';
import { Table } from '@wix/design-system';
import { CommonEmptyState, CommonEmptyStateProps } from '../CommonEmptyState';

export interface CommonTableEmptyStateProps
  extends Partial<CommonEmptyStateProps> {
  children?: ReactNode;
}

/**
 * @deprecated
 * Use instead: `import { CollectionEmptyState } from '@wix/cairo';`
 */
export function CommonTableEmptyState(props: CommonTableEmptyStateProps) {
  const { children, ...rest } = props;

  return (
    <CommonEmptyState component={Table.EmptyState} {...rest}>
      {children}
    </CommonEmptyState>
  );
}
